import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppStateService } from '../../app-state.service';
import { GoogleMapsService } from '../../google-maps.service';
import { ClinicInformation } from '../clinic.model';
import { FormConfigService } from '../forms-config.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-clinic-info',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './clinic-info.component.html',
  styleUrl: './clinic-info.component.scss'
})
export class ClinicInfoComponent {

  snackBar = inject(MatSnackBar);
  formConfigService = inject(FormConfigService);
  appStateService = inject(AppStateService);
  googleMapsService = inject(GoogleMapsService);
  patientId: string;
  clientId: string;
  searchControl = new FormControl('');
  breakpointObserver = inject(BreakpointObserver);
  balanceItems: any[] = [];
  accountAgingBalance: any = {};
  clinicInfo: ClinicInformation = {} as ClinicInformation;
  loading = false;
  dialogRef = inject(MatDialogRef<ClinicInfoComponent>);

  constructor() {
    this.clientId = this.appStateService.getState().clientId || '';
    this.patientId = this.appStateService.getState().patientId || '';
    this.clinicInfo = this.appStateService.getState().clinicInfo || {} as ClinicInformation;
    if (!this.clinicInfo) {
      this.formConfigService.fetchClientInfo(this.clientId).subscribe({
        next: (data: any) => {
          this.clinicInfo = data;
        },
        error: (error: any) => {
          this.showError('Error fetching clinic information.');
        }
      });
    }
  }

  showError(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
    });
  }
  
  /* Handling Image Load Errors */
  onImgError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/client-logo.png';
  }
  
  getLogoUrl(): string {
    // Validate the logo URL before using it
    if (this.clinicInfo.logoUrl) {
      const trimmedUrl = this.clinicInfo.logoUrl.trim();
      if (trimmedUrl && 
          (trimmedUrl.startsWith('http://') || 
           trimmedUrl.startsWith('https://') ||
           trimmedUrl.startsWith('assets/') ||
           trimmedUrl.startsWith('/'))) {
        return trimmedUrl;
      }
    }
    return 'assets/client-logo.png';
  }

  navigateToClinic(): void {
    if (!this.clinicInfo.address) {
      this.showError('Clinic address is not available.');
      return;
    }
    const address = this.clinicInfo.address;
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`, '_blank');
  }

  callClinic() {
    window.location.href = 'tel:' + this.clinicInfo.phoneNumber;
  }

}
